import { Link } from "react-router-dom";
import { CLINIC } from "@/constants/clinic";

export const Footer = () => (
  <footer className="border-t border-slate-100 bg-background" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col md:flex-row gap-6 justify-between text-sm text-muted-foreground">
      <div>
        <p className="font-display font-semibold text-[#1A252C]">{CLINIC.name}</p>
        <p className="mt-1">{CLINIC.title}, {CLINIC.city}</p>
        <p className="mt-4 max-w-md text-xs">This website is for information and appointment booking only. In a medical emergency, please visit the nearest hospital immediately.</p>
      </div>
      <div className="md:text-right">
        <Link to="/admin/login" className="hover:text-primary" data-testid="footer-staff-login">Staff login</Link>
        <p className="mt-4">© {new Date().getFullYear()} {CLINIC.name}</p>
      </div>
    </div>
  </footer>
);
